'use client';

import { ComponentProps } from 'react';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import { useExperiments } from '@alltrails/experiments';
import { useIntl } from 'react-intl';
import styles from './styles/styles.module.scss';

export type SearchBoxProps = Pick<
  ComponentProps<typeof AlgoliaSearchBox>,
  | 'clearOnSelect'
  | 'configs'
  | 'getCurrentLatLng'
  | 'navigateOnSelect'
  | 'onAddressSelect'
  | 'onAiSearchSelect'
  | 'onInputBlur'
  | 'onInputFocus'
  | 'onResultSelect'
  | 'tertiaryElement'
  | 'value'
  | 'searchRequestLoading'
>;

const SearchBox = (searchProps: SearchBoxProps) => {
  const intl = useIntl();
  const aiSearchEnabled = useExperiments()['web-ai-natural-language-search']?.value === 'treatment';

  return (
    <div className={styles.searchBox}>
      <AlgoliaSearchBox
        {...searchProps}
        aiSearchEnabled={aiSearchEnabled}
        dropdownVariant="enveloping"
        placeholder={intl.formatMessage({ defaultMessage: 'Search' })}
        searchOrigin="global nav"
        searchTypes="all"
        testId="header-search"
        variant="subtle"
        useTypeAhead
      />
    </div>
  );
};
export default SearchBox;
